import { loadChiliPiperScript } from "./chiliPiperScriptLoader";

const CHILI_PIPER_DOMAIN = "circle-co";

const CHILI_PIPER_ROUTERS = {
  PRODUCT: "product",
} as const;

export const PRODUCT_UTM_CAMPAIGNS = {
  UPGRADE_PLAN: "upgradeplan",
  UPGRADE_PLAN_EXP: "upgradeplanexp",
  PLUS_PAGE: "pluspage",
  PLUS_PLAN_EXP: "plusplanexp",
  PLUS_PAGE_EXP: "pluspageexp",
  USAGE_MODAL: "usagemodal",
  USAGE_MODAL_EXP: "usagemodalexp",
  TRIAL_EXPIRED_BANNER: "trialexpiredbanner",
  GET_STARTED_DLC_PLUS: "getstarteddlcplus",
  GET_STARTED_DLC_PLUS_EXP: "getstarteddlcplusexp",
  SSO_UPGRADE: "ssoupgrade",
  SSO_UPGRADE_EXP: "ssoupgradeexp",
  CIRCLE_AI: "circleai",
  CIRCLE_AI_HARD: "caih",
  CIRCLE_AI_SOFT: "cais",
  CIRCLE_AI_PRODUCT: "caip",
  CIRCLE_AI_PROACTIVE: "caipro",
  CIRCLE_AI_ONBOARDING: "caiob",
  CIRCLE_AI_PLANS_PAGE: "caiplusfit",
  CIRCLE_AI_SSO: "AI_SSO",
  CIRCLE_AI_BRANDED_APPS: "AI_brandedapps",
  CIRCLE_AI_AI_AGENTS: "AI_AIAgents",
  REPLIT_ONBOARDING_MODAL: "websufcai",
  TRIAL_SIDEBAR_BADGE: "trialsidebarbadge",
} as const;

export type ProductUtmCampaign =
  (typeof PRODUCT_UTM_CAMPAIGNS)[keyof typeof PRODUCT_UTM_CAMPAIGNS];

export const isProductUtmCampaign = (
  value: unknown,
): value is ProductUtmCampaign =>
  typeof value === "string" &&
  (Object.values(PRODUCT_UTM_CAMPAIGNS) as string[]).includes(value);

export interface ChiliPiperBookingArgs {
  assigneeId: string;
  eventId: string;
  redirectUrl?: string;
  routeId: string;
  slot: {
    start: string;
    end: string;
  };
}

export interface ChiliPiperConfig {
  lead: Record<string, unknown>;
  onSuccess?: (args: ChiliPiperBookingArgs) => void;
  router: string;
  trigger: string;
}

const triggerChiliPiper = async (config: ChiliPiperConfig): Promise<void> => {
  try {
    await loadChiliPiperScript();

    if (window.ChiliPiper) {
      window.ChiliPiper.submit(CHILI_PIPER_DOMAIN, config.router, {
        trigger: config.trigger,
        lead: config.lead,
        onSuccess: (args?: unknown) => {
          config.onSuccess?.(args as ChiliPiperBookingArgs);
        },
      });
    }
  } catch (error) {
    console.error("Failed to load or trigger ChiliPiper:", error);
  }
};

const SALES_UTM_SOURCE = "Product";

export const triggerChiliPiperProductRouter = async (
  email: string,
  campaign: string,
  onSuccess?: (args: ChiliPiperBookingArgs) => void,
): Promise<void> =>
  triggerChiliPiper({
    lead: {
      email,
      sales_utm_source: SALES_UTM_SOURCE,
      sales_utm_campaign: campaign,
    },
    onSuccess,
    router: CHILI_PIPER_ROUTERS.PRODUCT,
    trigger: "InAppButton",
  });
